<template lang="pug">
div.confirm-layout
  div.alert.alert-success
    span 管制組藥退藥（{{ currentMed.parent_medication.generic_name }}）
  ConfirmReason(
    v-if="stage === 'selectReason'"
    v-on:setReason="getReason"
  )
  div.confirm-form(v-if="stage === 'confirm'")
    h5.text-center 選擇使用情形 ({{setIndex + 1}}/{{this.controlMedSet.length}})
    div.button-wrap(@click="setReturnStatus('RECYCLE_EMPTY')")
      button.btn.btn-lg.confirm-button 已使用（退空瓶）
    div.button-wrap(@click="setReturnStatus('RETURN')")
      button.btn.btn-lg.confirm-button 未使用（退藥）
  Action(
      v-if="stage === 'action'"
      v-on:setActionData="getThisAmount" 
      :inputReadOnly="true"
      :defaultNum="forAction.defaultNum"
      :deviceId="forAction.deviceId"
      :checkNum="forAction.checkNum"
      :defaultPackCount="0"
      :limitPackCount="false"
    )
    h5
      strong
        span 退回管制組藥
  Loader(
    v-if="stage === 'finish'"
  )
</template>

<script>
import axios from 'axios';
import Action from '../flowComp/Action';
import ConfirmReason from '../flowComp/Reason';
import Loader from '../common/Loader';

export default {
  name: 'ReturnEmptyBottle',
  props: [
    'controlMed',
  ],
  data() {
    return {
      stage: null,
      controlMedSet: null,
      forAction: null,
      currentMed: null,
      eventRecordPromises: [],
      setIndex: 0,
      emitTimes: 0,
      reasonId: null,
    };
  },
  created() {
    this.getControlSet();
    this.promises = [];
    this.stage = 'selectReason';
  },
  components: {
    Action,
    ConfirmReason,
    Loader,
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
    currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    currentEvent() {
      return this.$store.state.event.currentEvent;
    },
  },
  methods: {
    getReason(reasonId) {
      this.reasonId = reasonId;
      this.stage = 'confirm';
    },
    getControlSet() {
      this.instance.get('/api/control-medication-set/', {
        params: {
          parent_medication: this.controlMed.id,
        },
      })
      .then((res) => {
        this.controlMedSet = res.data;
        this.setCurrentMed(0);
      });
    },
    setCurrentMed(index) {
      this.setIndex = index;
      this.currentMed = this.controlMedSet[index];
      this.$store.dispatch('setDrug', this.currentMed.child_medication.id);
    },
    setReturnStatus(status) {
      // 管制藥組內的藥物僅直接紀錄，不調整drugStorage.
      if (status !== 'RECYCLE_EMPTY' || status !== 'RETURN') {
        const event = {
          event_type: status,
          patient_name: this.currentSchedule.patient.name,
          med_record_no: this.currentSchedule.patient.med_record_number,
          medication: this.currentMed.child_medication.id,
          medication_generic_name: this.currentMed.child_medication.generic_name,
          employee: this.$store.state.user.user.id,
          employee_name: `${this.$store.state.user.user.last_name}${this.$store.state.user.user.first_name}`,
          device: this.currentDrugInDevice.device.id,
          stock: this.currentMed.child_medication_quantity,
          total_stock: this.currentMed.child_medication_quantity,
          number1: this.currentMed.child_medication_quantity,
          number2: this.currentSchedule.id,
          reason: this.reasonId,
          checked: true,
        };
        this.promises.push(this.instance.post('/api/event/', event));
      }
      // if this is the last one med in set, then go to action.
      if (this.setIndex + 1 === this.controlMedSet.length) {
        this.forAction = {
          deviceId: this.currentDrugInDevice.device.id,
          defaultNum: 1,
          checkNum: 1,
        };
        this.stage = 'action';
      } else {
        this.setCurrentMed(this.setIndex + 1);
      }
    },
    saveControlSetParentMed(data) {
      const drugStorage = {
        device: this.currentDrugInDevice.device.id,
        stock: this.currentDrugInDevice.stock, // not quite sure whether the control medication set would only with one stock.
        max_stock: this.currentDrugInDevice.max_stock,
        expired_date: this.currentDrugInDevice.expired_date,
        patch_number: this.currentDrugInDevice.patch_number,
        medication: this.currentDrugInDevice.medication.id,
        reason: this.reasonId,
        med_record_no: this.currentSchedule.patient.med_record_number,
        number1: data.num,
        number2: this.currentSchedule.id,
        pack_count: 0,
        type: 'RETURN',
      };
      this.promises.push(this.instance.put(`/api/drug-storage/${this.currentDrugInDevice.id}/`, drugStorage));
      this.promises.push(this.instance.patch(`/api/event/${this.currentEvent.id}/`, { checked: true }));
    },
    getThisAmount(data) {
      console.log(data);
      if (this.emitTimes === 0) {
        this.stage = 'finish';
        this.saveControlSetParentMed(data);
        axios.all(this.promises)
        .then((res) => {
          this.$emit('returnEmptyBottleFinish');
        });
      }
      this.emitTimes += 1;
    },
  },
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// ReturnEmptyBottle.vue?655e040e